var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"el",staticClass:"k2-pop",class:'k2-pop--' + _vm.kind,style:(_vm.style),attrs:{"role":_vm.role,"aria-label":_vm.label}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }